import './Checkout.scss'
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import {Button, Col, Container, Form, InputGroup, Row} from "react-bootstrap";
import {useContext, useEffect, useState} from "react";
import AppContext from "../AppContext";
import {FaCheck} from "react-icons/fa6";
import {useParams} from "react-router-dom";
import API, {HandleError} from "../API";
import {useSnackbar} from "notistack";
import {Plan} from "../models/Plan";
import {BiTrash} from "react-icons/bi";
import {useTranslation} from "react-i18next";

export default function Checkout() {
    const app = useContext(AppContext)
    const { t, i18n } = useTranslation();
    const { enqueueSnackbar } = useSnackbar()
    const [loading, setLoading] = useState(true)
    const [plan, setPlan] = useState(null)
    const [coupon, setCoupon] = useState({
        value: '',
        show: false,
        error: false,
        message: '',
        test: false,
        applied: false
    })

    const { plan_id } = useParams();
    useEffect(() => {
        getPlan()
    }, [])
    useEffect(() => {
        if(coupon.test)
            getPlan()

    }, [coupon.test])
    const getPlan = async () => {
        setLoading(true)
        try {
            const res = await API({
                method: 'GET',
                url: `/plan/${plan_id}?coupon=${coupon.value}`,
                headers: {
                    'Authorization': `Bearer ${app.token}`,
                }
            })

            if (res.status < 200 || res.status > 299)
                throw res.data;

            setPlan(new Plan(res.data.item))
            //console.log(res.data.item.price_breakdown)
            setLoading(false)
            if(res.data?.error) {
                setCoupon({...coupon, error: true, message: res.data.error, test: false, applied: false})
            }
            else {
                setCoupon({...coupon, error: false, message: '', test: false, applied: !!coupon.value})
            }
        }
        catch(e) {
            setLoading(false)
            HandleError(e, 'Error', enqueueSnackbar, app.logout);
        }
    }

    const handleCouponInput = (e) => {
        setCoupon({...coupon, value: e.target.value })
    }
    const hideCoupon = () => {
        setCoupon({
            value: '',
            show: false,
            error: false,
            message: '',
            applied: false
        })
    }
    const clearCoupon = () => {
        setCoupon({...coupon,
            value: '',
            error: false,
            message: '',
            test: true,
            applied: false
        })
    }
    const showCoupon = () => {
        setCoupon({
            value: '',
            show: true,
            error: false,
            message: '',
            applied: false
        })
    }

    const goToPayment = async () => {
        setLoading(true)
        try {
            const res = await API({
                method: 'POST',
                url: `/checkout/${plan_id}`,
                headers: {
                    'Authorization': `Bearer ${app.token}`,
                },
                data: {
                    coupon: coupon.value
                }
            })

            if (res.status < 200 || res.status > 299)
                throw res.data;

            window.location.href = res.data.payment_url;
        }
        catch(e) {
            setLoading(false)
            HandleError(e, 'Error', enqueueSnackbar, app.logout);
        }
    }

    return <div id="page-checkout" className={"page " + (app.ui.isDrawerOpen ? 'menu-shown' : '')}>
        <Sidebar />
        <div className="page-inner">
            <Header />
            <Container style={{maxWidth: 800, textAlign: "center"}}>
                <h1 className="text-center title">{t('checkout.title')}</h1>
                <h3 className="text-center text-muted">
                    {t('checkout.subtitle')}
                </h3>
                <div className="pricing-section mt-5">
                    <Row className="card-deck mb-3 text-left">
                        <Col md={12} style={{maxWidth: 600}} className="ms-auto me-auto">
                            <div className="card mb-4">
                                <div className="card-header py-3">
                                    <h4 className="my-0">{t('checkout.plan')}: {plan?.name}</h4>
                                </div>
                                <div className="card-body">
                                    <p className="card-title pricing-card-title mt-0">
                                        <small className="text-muted">SKU: {plan?.sku}</small>
                                    </p>
                                    <p className="mb-4">
                                        {plan?.description}
                                    </p>
                                    <div className="mb-4">
                                        {coupon.show ?
                                            <Row>
                                                <Col md={6}>
                                                    <InputGroup controlId="coupon">
                                                        <Form.Control type="text" placeholder={t('checkout.couponCode')}
                                                                      name="coupon" value={coupon.value}
                                                                      onChange={handleCouponInput} readOnly={coupon.applied && coupon.value} />
                                                        {!!coupon.value && <Button variant="outline-secondary" id="button-addon1" onClick={clearCoupon}>
                                                            <BiTrash />
                                                        </Button>}
                                                    </InputGroup>
                                                    {coupon.error && coupon.value ? <Form.Text className="text-danger">
                                                        {coupon.message}
                                                    </Form.Text> : ''}
                                                </Col>
                                                <Col md={6}>
                                                    {!coupon.applied && <Button variant="info" onClick={getPlan}>{t('button.apply')}</Button>}
                                                </Col>
                                            </Row> :
                                            <div>
                                                <Button variant="info" onClick={showCoupon}>{t('checkout.haveCoupon')}</Button>
                                            </div>}
                                    </div>
                                    <table className="table table-bordered">
                                        <tbody>
                                        {plan !== null && Object.keys(plan.price_breakdown).map((k, idx) => {
                                            let data = plan.price_breakdown[k]
                                            if(data['amount'] === 0)
                                                return null

                                            return <tr key={"pbreakdown-" + k}>
                                                <th style={{ textAlign: 'right'}}>{data['name']}</th>
                                                <td style={{ textAlign: 'right', width: 120}}>
                                                    &euro;{data['amount']}
                                                </td>
                                            </tr>
                                        })}
                                        </tbody>
                                    </table>
                                    <button type="button" disabled={coupon.error && coupon.value}
                                            onClick={goToPayment}
                                            className="btn btn-lg btn-block btn-primary w-100">{t('checkout.payWithIdeal')}</button>

                                    {coupon.error && coupon.value ? <div className="text-center mt-2"><Form.Text className="text-danger text-center">
                                        {t('checkout.invalidCoupon')}
                                    </Form.Text>
                                    </div> : ''}
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </Container>
        </div>
    </div>
}